import {Component, Input} from '@angular/core';

@Component({
   selector: 'app-promotion-detail',
   templateUrl: './promotion-detail.component.html',
   styleUrls: ['./promotion-detail.component.css']
})
export class PromotionDetailComponent {

   @Input() promotionData: any;
   minDate = new Date();
   constructor() {
      this.promotionData = {
         'promoName': '',
         'status': 'enable',
         'promoCode': '',
         'promoPeriodType': 'period of time',
         'promoPeriod': 'monthly',
         'maximumPromoType': 'limited',
         'maximumPromo': '',
         'promoDiscountType': 'percent',
         'promoDiscount': '',
         'maximumDiscount': '',
      }
   }
}
